(function(){
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function gal(root){
    var main=root.querySelectorAll('[data-fem-main] img');
    var thumbs=root.querySelectorAll('[data-fem-thumb]');
    thumbs.forEach(function(t,i){
      t.addEventListener('click',function(){
        main.forEach(function(m,j){m.hidden=(j!==i);});
        thumbs.forEach(function(x,j){x.setAttribute('aria-current',j===i?'true':'false');});
      });
    });
  }
  function sticky(bar,anchor){
    if(!bar||!anchor||!('IntersectionObserver' in window))return;
    new IntersectionObserver(function(entries){
      var e=entries[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    },{threshold:0}).observe(anchor);
  }
  function qty(root){
    var i=root.querySelector('[data-fem-qty]');if(!i)return;
    root.querySelectorAll('[data-fem-step]').forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(i.value,10)||1;v+=parseInt(b.dataset.femStep,10);
        i.value=Math.max(1,v);i.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
  }
  function variants(root){
    var sel=root.querySelector('[data-fem-variant]');if(!sel)return;
    root.querySelectorAll('[data-fem-sw]').forEach(function(b){
      b.addEventListener('click',function(){
        root.querySelectorAll('[data-fem-sw]').forEach(function(x){x.setAttribute('aria-checked','false');});
        b.setAttribute('aria-checked','true');
        sel.value=b.dataset.femSw;
        var p=root.querySelector('[data-fem-price]'),c=root.querySelector('[data-fem-compare]');
        if(p&&b.dataset.femPrice)p.textContent=b.dataset.femPrice;
        if(c&&b.dataset.femCompare)c.textContent=b.dataset.femCompare;
      });
    });
  }

  /* ---- carrello: aggiunta in AJAX + apertura drawer ---- */
  function getDrawer(){ return document.querySelector('cart-drawer'); }

  function setBtnState(btn, state){
    if(!btn) return;
    btn.classList.remove('is-loading','is-done');
    if(state) btn.classList.add(state);
    btn.disabled = (state === 'is-loading');
  }

  function bumpCartIcon(){
    var b = document.querySelector('.cart-count-bubble, #cart-icon-bubble');
    if(!b) return;
    b.classList.remove('fem-bump');
    void b.offsetWidth;
    b.classList.add('fem-bump');
  }

  function ajaxAdd(form, btn){
    var drawer = getDrawer();
    var fd = new FormData(form);
    if (drawer && typeof drawer.getSectionsToRender === 'function'){
      try{
        fd.append('sections', drawer.getSectionsToRender().map(function(s){return s.id;}).join(','));
        fd.append('sections_url', window.location.pathname);
      }catch(e){}
    }
    setBtnState(btn,'is-loading');
    return fetch(ROOT + 'cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: fd
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, data:j}; }); })
      .then(function(res){
        if(!res.ok){ throw new Error((res.data && res.data.description) || 'errore'); }
        setBtnState(btn,'is-done');
        setTimeout(function(){ setBtnState(btn,null); }, 1800);
        bumpCartIcon();
        if (drawer && typeof drawer.renderContents === 'function'){
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.data);
          if (typeof drawer.open === 'function') { try{ drawer.open(); }catch(e){} }
        } else {
          window.location.href = ROOT + 'cart';
        }
        return res.data;
      })
      .catch(function(err){
        setBtnState(btn,null);
        form.submit();
      });
  }

  function bindForm(form){
    if(!form || form.dataset.femBound) return;
    form.dataset.femBound = '1';
    form.addEventListener('submit', function(ev){
      if(!getDrawer()) return; /* nessun drawer nel tema: lascia il comportamento nativo */
      ev.preventDefault();
      var btn = form.querySelector('[type=submit]');
      ajaxAdd(form, btn);
    });
  }

  function init(){
    document.querySelectorAll('[data-fem-product]').forEach(function(r){gal(r);qty(r);variants(r);});
    sticky(document.querySelector('[data-fem-sticky]'),document.querySelector('[data-fem-anchor]'));
    document.querySelectorAll('form[action*="/cart/add"]').forEach(bindForm);
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
